import { LoadingBox } from '@assets/tsx/loadingBox/loadingBox';
import React, { Suspense } from 'react';
const OsMapLazy = React.lazy(() => import('./os-map-component'));
export default function OsMap(props) {
    return React.createElement(Suspense, { fallback: React.createElement(LoadingBox, { style: { height: 600 } }) },
        React.createElement(OsMapLazy, Object.assign({}, props)));
}
